import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

import storeHelper from '@/store/helper'
import FileDownload from 'js-file-download'
import moment from 'moment'
import axios from 'axios'
import {getUrl, Post} from "@/services/customer-support";

// axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'

export class ContractService extends BaseService {
  static async getList (params = {}) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.get-list-contract'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getPriceProposals (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.appendix.search-price-proposals'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async createPriceProposal (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.appendix.create-price-proposal'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }


  static async approveProposalPrice (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.appendix.approve-price-proposal'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async cancelProposalPrice (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.appendix.cancel-price-proposal'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }


  static async rejectProposalPrice (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.appendix.reject-price-proposal'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getProposals (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.appendix.list-price-proposals'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getSignHistory (contractId) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.contract.get-history'), { contractId })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async comfirmDetailHDDTAppendix (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.e_scon.ma-approve-fee-with-contract-existed'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async approvedAppendixWithContract (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.e_scon.ma-approved-fee-with-contract-new'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async insertContract (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.save'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async editMccMerchant (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.mcc-update'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateMccMerchantPaperContract (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.update-info-customer'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async editSerialDevice (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.sa-update-serial-number-device'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async editSerialDeviceEContract (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.appendix.edit'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async editAppendixPaperContract (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.edit-appendix-paper-contract'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async saveImg (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.save-images'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async createVisaAppendix (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.create-visa-appendix'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async uploadPdf (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cfg.file-upload'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async uploadFileS3PDF (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cfg.upload-files-s3'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async previewAndPdf (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.common.preview-and-pdf'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async previewAndPdf2 (params) {

    try {
      const response = await axios.post(`${process.env.VUE_APP_GET_CCRP_REVIEW}/api/scon/common/v2/preview-and-pdf`, { econtractId: params.econtractId, type: params.type }, {
        headers: {
          Authorization: 'Bearer ' + params.token
        }
      })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getDetailContract (params) {

    try {
      const response = await axios.post(`${process.env.VUE_APP_GET_CCRP_REVIEW}/api/scon/common/v2/detail-by-code`, { code: params.code, groupService: params.groupService }, {
        headers: {

          Authorization: 'Bearer ' + params.token
        }
      })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getContractById (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.e_scon.find-econtract-by-id'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getContractById_V1 (params) {

    try {
      const response = await axios.post(`${process.env.VUE_APP_GET_CCRP_REVIEW}/api/scon/econtract/v1/detail`, { econtractId: params.econtractId }, {
        headers: {

          Authorization: 'Bearer ' + params.token
        }
      })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getDetailContractByID_V2 (params) {

    try {
      const response = await axios.post(`${process.env.VUE_APP_GET_CCRP_REVIEW}/api/scon/contract/get-detail-contract-web`, params, {
        headers: {

          Authorization: 'Bearer ' + params.token
        }
      })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async insertImage (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.save-image'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getByCode (params) {

    try {
      // const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.get-contract-detail-by-code'), params)
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.common.detail-by-code'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getDetailContractByID (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.contract.get-detail-contract-web'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getTranferByIDContract (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.receipt.get-by-contract'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getDetailPaperContractById (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.detail-paper-contract'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getPreviewPaperContractById (params) {

    try {
      const response = await axios.post(`${process.env.VUE_APP_GET_CCRP_REVIEW}/api/scon/pcontract/detail-paper-contract`, { contractId: params.contractId }, {
        headers: {
          Authorization: params.token
        }
      })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async rejectContract (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.reject-contract'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async rejectSAContract (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.common.sa-rejected'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async rejectPaperContract (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.reject-paper-contract'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async approvedContract (params) {

    try {
      // const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.approved-contract'), params)
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.common.sa-approved'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getLinkPDFBusinessContract (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.get-link-pdf-contract'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async actionPaperContract (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.action-paper-contract'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async approvedApendix (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.e_scon.sa-approved-appendix'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async actionAppendix (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.appendix.action'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getAppendixById (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.appendix.get'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async actionApendixPaperContract (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.action-appendix-paper-contract'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateImg (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.contract-upload-images'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getCodeContractByCustomer (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.get-code-contract-by-customer-id'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async addStaff (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.staff.upsert-staff'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getRoleByUser (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.sur.user-get-roles-by-user-id'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async setRole (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.staff.set-role'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getCityByUserId (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.sur.get-user-info-by-id'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async changePassword (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.staff.change-password'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async fillPermissionByUser (params = {}) {

    try {
      const response = await this.request({ auth: true }).post('https://dev-cloud.fastgo.mobi:31801/cfg/get-endpoint', params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getStaffById (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.sur.get-user-info-by-id'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async lockOfUnlockStaff (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.staff.set-status'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async saveLinkPFD (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.e_scon.save-econtract-approved-by-pdf-file'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async saveLinkPDF_V2 (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.econtract.generation-pdf-all'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async genPDFByServer (params) {
    try {
      const response = await this.request({ auth: true }).post(`${process.env.VUE_APP_GEN_PDF}/api/v2/gen-pdf`, params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async genPDFByServer_Appendix (params) {

    try {
      const response = await this.request({ auth: true }).post(`${process.env.VUE_APP_GEN_PDF}/api/v2/gen-pdf-appendix`, params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async genPDFByServer_Megadoc (params) {

    try {
      const response = await axios.post(`${process.env.VUE_APP_GEN_PDF}/api/v2/gen-pdf-megadoc`, params, {
        headers: {
          Authorization: params.token
        }
      })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async genPDF_Megadoc_Appendix (params) {

    try {
      const response = await axios.post(`${process.env.VUE_APP_GEN_PDF}/api/v2/gen-pdf-megadoc-appendix`, params, {
        headers: {
          Authorization: params.token
        }
      })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getLinkPDF (params = {}) {

    try {
      const response = await axios.post(`${process.env.VUE_APP_GET_CCRP_REVIEW}/api/scon/econtract/v1/get-url-s3-pdf`, params, {
        headers: {
          Authorization: 'Bearer ' + process.env.VUE_APP_INSIDE_TOKEN
        }
      })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getLinkPDF_s3_v2 (params = {}) {

    try {
      // const response = await this.request({ auth: false }).post(storeHelper.getUrl('cnps.scon.common.get-url-s3-contract-pdf'), params)
      const response = await axios.post(storeHelper.getUrl('cnps.scon.common.get-url-s3-contract-pdf'), params, {
        headers: {
          Authorization: 'Bearer ' + process.env.VUE_APP_INSIDE_TOKEN
        }
      })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getLinkPDFS3 (params = {}) {

    try {
      const response = await this.request({ auth: true }).get(storeHelper.getUrl('cnps.cfg.file-read'))
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getRegions () {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.unit.get-list-region'), {})
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async resetPassword (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.staff.reset-password'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async deletedStaff (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.staff.delete-staff'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getAllCity (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cfg.city-list'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getDistictByCode (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cfg.district-list'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getProvinceRegion (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.unit.get-list-province-by-region'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async export (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.attn.export-attendance'), params, {
        responseType: 'blob'
      })
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(response.data, 'Report-attendance' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getStaffByIdSuperior (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.staff.download-template-staff'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getRoleList () {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cfg.role-list'), {})
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async superiors () {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.staff.list-manager'), {})
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async additionalContract (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.e_scon.request-additional-image'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async rejectContractMpos (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.e_scon.sa-reject-contract-mpos'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getDetailPaperByCode (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.detail-by-code'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async saveMixFiles (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.save-mix-files'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListAppendixContract (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.appendix.get-list-appendix-web'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async detailAppendixContract (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.contract.get-detail-appendix-web'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportListAppendixContract (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.appendix.export-appendix-web'), params, {
        responseType: 'blob'
      })
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(response.data, 'List_Appendix_Contrac' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListContract (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.contract.get-list-contract-web'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
    static async getListContractMegabiz (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.contract.get-list-contract-megabiz'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
   static async getListStatusMegabiz (params) {

    try {
      const response = await this.request({ auth: true }).get(storeHelper.getUrl('cnps.scon.cfg.contract-megabiz'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

     static async updateMegabozStatus (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.contract.set-stt-megabiz'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }



  static async getListContractSell (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.contract.get-list-contract-sell'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListContractPayment (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.contract.get-list-contract-payment'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async actionCollaborator (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.e_scon.action-collaborator'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      // const message = error.response.data ? error.response.data.error : error.response.statusText
      // throw new ErrorWrapper(error, message)
      return error.response
    }
  }

  static async actionApproveCommission (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.e_scon.action-collaborator-fee'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      return error.response
    }
  }

  static async rollbackContractState (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.common.rollback-state-to-waiting-approved'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async resendEmail (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.integ.email.resend-email-again'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }


  static async checkDetailMposMc (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.check-detail-mpos-mc'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async actionResendOTP (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.integ.otp.action-otp'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      return error.response
    }
  }

  static async assignNewSale (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.contract.assign-sale'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      return error.response
    }
  }

  static async exportExcel (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.contract.export-contract-web'), params, {
        responseType: 'blob'
      })
      FileDownload(response.data, 'Export_Contract' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportExcelSell (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.contract.export-contract-sell'), params, {
        responseType: 'blob'
      })
      FileDownload(response.data, 'Export_Contract_SELL' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportExcelPayment (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.contract.export-contract-payment'), params, {
        responseType: 'blob'
      })
      FileDownload(response.data, 'Export_Contract_PAYMENT' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getAppendixByIdInPublic (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.appendix.info-contract-handover'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async editFiles (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.edit-files'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response?.data ? error.response?.data.error : error.response?.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async additionalUpload (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.additional-upload'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response?.data ? error.response?.data.error : error.response?.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async contractConfirmInvoice (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.contract.confirm-invoice'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async contractUpdateInfoInvoice (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.contract.update-info-invoice'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async editFiles (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.edit-files'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response?.data ? error.response?.data.error : error.response?.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async additionalUpload (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.additional-upload'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response?.data ? error.response?.data.error : error.response?.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async contractConfirmInvoice (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.contract.confirm-invoice'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async contractUpdateInfoInvoice (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.contract.update-info-invoice'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListAppendixVisa (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.appendix.get-list-appendix-visa'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async removeDevice (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.contract.remove-device-from-contract'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async rejectAppendixVisa (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.appendix.reject-visa-appendix'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async onOffVinvoice (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.on-off-vinvoice'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async policyEcontract (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.e_scon.ma-confirm-policy-econtract'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async confirmHandleHandover (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.appendix.handle-handover'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async confirmMultiFunctional (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.e_scon.ma-confirm-mfn-appendix'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async genPDFByServer_AppendixLen (params) {
    try {
      const response = await this.request({ auth: true }).post(`${process.env.VUE_APP_GEN_PDF}/api/v2/gen-pdf-loan-appendix`, params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async confirmInfoAppendix (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.appendix.action-appendix-by-operate'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateMerchantKeyToNormal (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.update-mc-lvl'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async listInfoChange (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.in4change.get-list'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async detailInfoChange (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.in4change.get-info-by-id'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async fetchHistoryInfoChange (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.in4change.get-action-log'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async approveInfoChange (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.in4change.approve-on-web'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListMerchantKeyOnus (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.order-mc-key-onus.get-list'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async rejectInfoChange (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.in4change.reject-on-web'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async createMerchantKeyOnus (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.order-mc-key-onus.create'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async additionalChange (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.in4change.need-additional'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateMerchantKeyOnus (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.order-mc-key-onus.update'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async additionalFile  (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.edit-files-appendix-change'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async detailMerchantKeyOnus (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.order-mc-key-onus.detail'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async historyMerchantKeyOnus (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.order-mc-key-onus.history'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async cancelMerchantKeyOnus (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.order-mc-key-onus.cancel'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async managerApprovalMerchantKeyOnus (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.order-mc-key-onus.manager-approval'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async managerRejectMerchantKeyOnus (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.order-mc-key-onus.manager-reject'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async managerRequestAddMerchantKeyOnus (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.order-mc-key-onus.manager-request-add'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async operationApprovalMerchantKeyOnus (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.order-mc-key-onus.operation-approval'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async operationApprovalAddMerchantKeyOnus (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.order-mc-key-onus.operation-approve-add'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async operationRejectAddMerchantKeyOnus (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.order-mc-key-onus.operation-reject-add'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async operationRequestAddAddMerchantKeyOnus (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.order-mc-key-onus.operation-request-add'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async operationPleaseAdviseAddMerchantKeyOnus (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.order-mc-key-onus.operation-please-advise'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async awaitManagerApprovalAddMerchantKeyOnus (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.order-mc-key-onus.await-manager-approval'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async sendManagerMerchantKeyOnus (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.order-mc-key-onus.send-manager'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateProfileMerchantKeyOnus (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.order-mc-key-onus.update-profile'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async addVietQrFee (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.appendix.add-vietqr-fee'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async removeVietQrFee (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.appendix.remove-vietqr-fee'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async listPaperContractManager (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.get-list-paper-contract-management'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async detailPaperContractManager (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.get-detail-paper-contract-management'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async actionSavePaperContract (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.action-save-paper-management'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async actionSavePaperContractSentAccoutant (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.sa-sent-paper-management'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async actionSavePaperContractAccoutantConfirm (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.accountant-save-paper-management'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async exportPaperContractManager (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.export-excel'), params, {
        responseType: 'blob'
      })
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(response.data, 'Danh sách quản lý PL/HĐ giấy' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async downloadFileTemplateSaleAdminConfirm (params = {}) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.download-template'), params, {
        responseType: 'blob'
      })
      console.log(response)
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(response.data, 'Import_SaleAdmin_Template' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async downloadFileTemplateSaleAdminConfirm (params = {}) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.download-template'), params, {
        responseType: 'blob'
      })
      console.log(response)
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(response.data, 'Import_SaleAdmin_Template' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async downloadFileTemplateAccountantReact (params = {}) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.export-template'), params, {
        responseType: 'blob'
      })
      console.log(response)
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(response.data, 'Import_Accountant_Template' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async importFileSaleAdminConfirm (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.import-data-save'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async importFileSendAccountant (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.receive-data'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async importFileAccountantReact (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.accountant-confirm-data'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async downloadSaleAdminError (params = []) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.download-file-error'), params, {
        responseType: 'blob'
      })
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(response.data, 'Import_SaleAdmin_Error' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async downloadAccountReactError (params = []) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.paper.download-file-confirm-error'), params, {
        responseType: 'blob'
      })
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(response.data, 'Import_Account_Error' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async checkDuplicateGpkd (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.check-duplicate-gpkd'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async listRecallDevice (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.appendix.recall-device-list'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async changeApprovedTwo (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.contract.change-approved-state'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
    static async changeApproveRejectMpos (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.contract.except-4-re-sign'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async changeFileAppendixMpos (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.change-file-appendix'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async listMcBIDV (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.reconciliationManagement.get-list'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateStatusMcBIDV (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.reconciliationManagement.action'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async downloadFileTemplateReconciliation (params = {}) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.reconciliationManagement.download-template'), params, {
        responseType: 'blob'
      })
      console.log(response)
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(response.data, 'Import_Reconciliation_Template' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async importFileReconciliation (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.reconciliationManagement.import-status-file'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async downloadReconciliationError (params = []) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.reconciliationManagement.download-file-error'), params, {
        responseType: 'blob'
      })
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(response.data, 'Import_SaleAdmin_Error' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async exportReconciliation (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.reconciliationManagement.export-excel'), params, {
        responseType: 'blob'
      })
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(response.data, 'Danh sách đối soát MC ưu đãi khi mở BIDV' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async changeStatus (params) {
         try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.scon.in4change.change-status-mc-confirm'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }


}

export const updateMcContract = async (params) => {
  return Post(getUrl('cnps.scon.contract.update-newMC-businessTransaction'), params)
}
